let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jy3XW")).then(() => parcelRequire('79Dsu'));